module.exports = __webpack_public_path__ + "app-static/img/yzz.50514990.png";